import { Blog } from "components/blog/blog.types";
import { DYLAN_LINKEDIN, LINKEDIN_URL } from "shared/constants/globals";

//Libum,Libum blog,Libum updates,Libum thoughts,Libum teamn updates

export const BLOG_ITEMS: Blog[] = [{
  id: 'we-have-a-blog',
  title: 'We Have a Blog?',
  description: `Fasten your seatbelts for our very first blog post.`,
  keywords: ['Libum', 'Libum blog', 'Libum vision', 'NexumAPI', 'Glaci', 'CU Build', 'Jack Henry Connect'],
  avatarPath: '/images/avatars/narwhal.svg',
  author: 'Dylan Martinez',
  authorBio: 'Co-Founder & Software Engineer',
  authorLabel: 'Dylan',
  authorLink: DYLAN_LINKEDIN,
  date: new Date('06/16/2023'),
}, {
  id: 'cu-building-the-future',
  title: 'CU Build*ing the Future with Brilliant Minds and a Snack Mountain',
  description: 'Follow our journey through a weekend of innovation, collaboration, and snacks.',
  keywords: ['Libum', 'Libum blog', 'Libum API', 'NexumAPI', 'SymXchange integration', 'CU Build integrating partners'],
  avatarPath: '/images/avatars/flag.svg',
  author: 'The Founders',
  authorBio: 'Don Nguyen & Dylan Martinez',
  authorLabel: 'Founders',
  authorLink: LINKEDIN_URL,
  date: new Date('08/04/2023'),
}, {
  id: 'new-year-new-site',
  title: 'New Year, New Site',
  description: 'Keeping things fresh with a site revamp and a portal in the works.',
  keywords: ['Libum', 'Libum blog', 'Libum website', 'Libum portal', 'PowerOn Pro', 'NexumAPI', 'Glaci'],
  avatarPath: '/images/avatars/walrus.svg',
  author: 'Dylan Martinez',
  authorBio: 'Co-Founder & Software Engineer',
  authorLabel: 'Dylan',
  authorLink: DYLAN_LINKEDIN,
  date: new Date('01/09/2025'),
}, {
  id: 'not-a-joke-poweron-pro',
  title: `This Isn't a Joke, PowerOn Pro+ Beta is Ending`,
  description: 'The PowerOn Pro beta is ending, and we are ready to launch.',
  keywords: ['Libum', 'Libum blog', 'PowerOn Pro', 'Libum portal', 'PowerOn', 'Jack Henry', 'Jack Henry cloud software'],
  avatarPath: '/images/avatars/walrus.svg',
  author: 'Dylan Martinez',
  authorBio: 'Co-Founder & Software Engineer',
  authorLabel: 'Dylan',
  authorLink: DYLAN_LINKEDIN,
  date: new Date('04/01/2025'),
}, {
  id: 'the-only-symitar-quest-overlay',
  title: 'Symitar Quest Just Got an Overlay',
  description: 'Imagine doing whatever you want, whenever you want, within Symitar Quest.',
  keywords: ['Libum', 'Libum blog', 'Glaci', 'Symitar Quest', 'Symitar', 'Jack Henry', 'Symitar overlay', 'Symitar quest overlay'],
  avatarPath: '/images/avatars/walrus.svg',
  author: 'Dylan Martinez',
  authorBio: 'Co-Founder & Software Engineer',
  authorLabel: 'Dylan',
  authorLink: DYLAN_LINKEDIN,
  date: new Date('10/11/2025'),
}];
